export function round(value, precision = 2) {
  //return +((value).toFixed(precision));
  const val = toFloat(value);
  const neg = (val < 0) ? -1 : 1;
  const mul = Math.pow(10, precision);
  return neg * (Math.round(Math.abs(val) * mul) / mul);
}

export function toFloat(value) {
  //return +(value);
  return Number.parseFloat(value);
}

export function normalizeFloat(string) {
  const parts = string.toString().replace(/\s/g, '').split(/[,.]/);
  let norm = '';

  if (parts.length === 1) {
    norm = parts[0];
  } else {
    norm = parts.slice(0, -1).join('') + '.' + parts.pop();
  }

  return toFloat(norm);
}

export function formatNumber(value, precision = 2) {
  const num = toFloat(value);
  if (Number.isNaN(num)) {
    return '';
  }
  return round(num, precision).toString().replace('.', ',');
}
